<table mat-table matSort #ownerslisttable class="simple-table">

    <ng-container matColumnDef="username">
        <th mat-header-cell *matHeaderCellDef i18n="@@ownerlist_username">Username</th>
        <td mat-cell *matCellDef="let element"> {{ element.username }} </td>
    </ng-container>

    <ng-container matColumnDef="displayName">
        <th mat-header-cell *matHeaderCellDef i18n="@@ownerlist_name">Nome</th>
        <td mat-cell *matCellDef="let element"> {{ element.displayName }} </td>
    </ng-container>

    <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef i18n="@@ownerlist_email">Email</th>
        <td mat-cell *matCellDef="let element"> 
            {{ element.email }} 
            <fa-icon icon="chevron-right" class="float-right padding-5"></fa-icon>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClicked(row)" 
        [class.mat-cell-selected]="selectedRow == row.id" class="clickable" >
    </tr>

</table>

<app-loading-screen #ownerslistloader></app-loading-screen>
